<section class="contact-us-section">
  <div class="container">
    <div class="breadcrumbs-container">
      <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
    </div>
    <div class="row">
      <div class="col-md-6">
        <h1 class="page-title">Get in Touch</h1>

        <div class="contactUs-info">
          <div class="d-flex gap-3 align-items-center">
            <img src="assets/icons/locationIcon.svg" class="img-fluid" alt="location" />
            <p>901 Market Street Suite 3020 Philadelphia, PA 19107</p>
          </div>
          <div class="d-flex gap-3 align-items-center">
            <img src="assets/icons/mailIcon.svg" class="img-fluid" alt="location" />
            <p>
              <a href="mailto:bridgecivic@economyleague.org">bridgecivic@economyleague.org</a>
            </p>
          </div>
          <div class="d-flex gap-3 align-items-center">
            <img src="assets/icons/phoneIcon.svg" class="img-fluid" alt="location" />
            <p>(267) 250-6480</p>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card formCard">
          <div class="card-body">
            <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
              <div class="form-group mb-0">
                <mat-form-field appearance="outline" class="full-width input_h_42 w-100">
                  <mat-label>Full Name</mat-label>
                  <input matInput formControlName="name" required [readonly]="isLoggedIn" />
                  <mat-error
                    *ngIf="contactForm.get('name')?.errors?.['required'] && contactForm.get('name')?.touched && !contactForm.get('name')?.pristine"
                    >Name is required</mat-error
                  >
                  <mat-error
                    *ngIf="contactForm.get('name')?.errors?.['minlength'] && contactForm.get('name')?.touched && !contactForm.get('name')?.pristine"
                    >Name must be at least 2 characters</mat-error
                  >
                </mat-form-field>
              </div>

              <div class="form-group mb-0">
                <mat-form-field appearance="outline" class="full-width input_h_42 w-100">
                  <mat-label>Email Address</mat-label>
                  <input
                    matInput
                    type="email"
                    formControlName="email"
                    required
                    [readonly]="isLoggedIn"
                  />
                  <mat-error
                    *ngIf="contactForm.get('email')?.errors?.['required'] && contactForm.get('email')?.touched && !contactForm.get('email')?.pristine"
                    >Email is required</mat-error
                  >
                  <mat-error
                    *ngIf="(contactForm.get('email')?.errors?.['email'] || contactForm.get('email')?.errors?.['pattern']) && contactForm.get('email')?.touched && !contactForm.get('email')?.pristine"
                    >Please enter a valid email address</mat-error
                  >
                </mat-form-field>
              </div>

              <div class="form-group mb-0">
                <mat-form-field
                  appearance="outline"
                  class="full-width select_h_42 w-100 custom-disabled-field"
                >
                  <mat-label>Type of User</mat-label>
                  <mat-select formControlName="userType" required [disabled]="isLoggedIn">
                    <mat-option *ngFor="let type of userTypes" [value]="type['value']">{{
                      type['label']
                    }}</mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="
                      contactForm.get('userType')?.hasError('required') &&
                      contactForm.get('userType')?.touched &&
                      !contactForm.get('userType')?.pristine
                    "
                    >Please select a user type</mat-error
                  >
                </mat-form-field>
              </div>

              <div class="form-group">
                <mat-form-field appearance="outline" class="full-width textarea_field w-100">
                  <mat-label>Your Query</mat-label>
                  <textarea
                    matInput
                    formControlName="message"
                    rows="5"
                    required
                    style="resize: none"
                  ></textarea>
                  <mat-error
                    *ngIf="contactForm.get('message')?.errors?.['required'] && contactForm.get('message')?.touched && !contactForm.get('message')?.pristine"
                    >Message is required</mat-error
                  >
                  <mat-error
                    *ngIf="contactForm.get('message')?.errors?.['minlength'] && contactForm.get('message')?.touched && !contactForm.get('message')?.pristine"
                    >Message must be at least 10 characters</mat-error
                  >
                  <mat-error
                    *ngIf="contactForm.get('message')?.errors?.['maxlength'] && contactForm.get('message')?.touched && !contactForm.get('message')?.pristine"
                    >Message cannot exceed 500 characters</mat-error
                  >
                </mat-form-field>
              </div>

              <button
                type="submit"
                class="btn submit-btn button-primary w-100 mt-3"
                [disabled]="contactForm.invalid"
              >
                <span>Submit</span>
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
